import React, { useRef, useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router";
import { connect } from "react-redux";

// IMPORT ACTION
import { getHistoryShipping } from "../../../actions/postalCodeAction";
import {
  doValidateOffer,
  doPostUserOffer,
  doBidValidation
} from "../../../actions/offerAction";
import { getHandbagConditions } from "../../../actions/productAction";

// IMPORT COMPONENT
import Graph from "./Graph/index"
import Table from "./Table/Table"
import DetailSection from "./DetailSection"
import { convertBrandNameToSlug } from 'utils/Helpers';

function DetailTPO({ propsForDetailSection, ...props }) {
  /* REACT HOOKS */
  const history = useHistory()
  const topSectionRef = useRef()
  const [noData, setNoData] = useState(false)

  /* PROPS */
  const {
    dataValidations,
    handbagCondition,
    productDetails: {
      vintage: isVintage = false
    }
  } = props
  /* DEFINE VARIABEL */
  const {
    product: dataProduct,
    dataInstallments: installments,
    isHideAllDetails,
    setHideAllDetails
  } = propsForDetailSection

  /* PROPERTIES */
  const propsForLeftContent = {
    isVintage,
    installments,
    dataValidations,
    handbagCondition,
    history,
    isHideAllDetails,
    setHideAllDetails,
    ...propsForDetailSection
  }

  useEffect(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: topSectionRef.current.getBoundingClientRect().top - 170,
    })

    if(dataProduct?.id){
      const params = props.match.params;
      const isUsingId = !isNaN(parseInt(params.id));
      const isIdUndefined = params.id === "undefined";
      
      if(isUsingId || isIdUndefined){
        const brand = dataProduct.product.brand;
        const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;
        const redirectUrl = `/${params.category}/${brandSlug}/${params.slug}`;
        history.replace(redirectUrl, { status: 301 });
      }
    }
  }, [dataProduct])

  return (
    <div ref={topSectionRef} className="product-details-top-section">
      <DetailSection propsForDetailSection={propsForLeftContent} />
      {(!isHideAllDetails && !noData) && <div className="graph-table-container">
        <Graph shoesData={dataProduct} setNoGraphData={setNoData} />
        <Table productData={dataProduct} />
      </div>}
    </div>
  )
}

const mapStateToProps = state => ({
  productDetails: state.dataProduct.productDetails,
  dataAuth: state.dataAuth,
  dataValidateOffer: state.dataOffer.validateOffer,
  dataPostalCode: state.dataPostalCode,
  dataCategory: state.dataCategory,
  dataValidations: { bid: state.dataOffer.bidValidation },
  handbagCondition: state.dataProduct.handbagCondition
});

const mapDispatchToProps = dispatch => ({
  validateOffer: (id, payload) => dispatch(doValidateOffer(id, payload)),
  doPostUserOffer: payload => dispatch(doPostUserOffer(payload)),
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  doBidValidation: () => dispatch(doBidValidation()),
  getHandbagConditions: productId => dispatch(getHandbagConditions(productId))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DetailTPO));
